import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Select from "react-select";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import validator from "validator";
import $ from "jquery";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import {
  showLoader,
  hideLoader,
  showAlert,
  userID,
  clientID,
  CompanyID,
  uploadFile,
  removeFile,
} from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import Editor from "../Layout/Editor";
var module = "company";
var moduleName = "Settings";
var modulePath = "/clientpanel/outlet";
var socilaMediaList = [
  { label: "Youtube", value: "Youtube" },
  { label: "Facebook", value: "Facebook" },
  { label: "Twitter", value: "Twitter" },
  { label: "Instagram", value: "Instagram" },
  { label: "Google+", value: "Google+" },
  { label: "Linkedin", value: "Linkedin" },
  { label: "Pinterest", value: "Pinterest" },
];
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageloading: false,
      clientdata: {
        companyName: "",
        companyWebSite: "",
        companyLogo: "",
        companyPostalCode: "",
        companyUnitNumber: "",
        companyFloorNumber: "",
        companyAddress: "",
        companyContactNumber: "",
        companyEmail: "",
        companyEnableTax:false,
        companyTaxType: "",
        companyEnableTaxPercentage: "",
        companyGSTNumber: "",
        companyInvoiceLogo: "",
        companyEnableLoyalty:false,
        companyLoyaltyEarnType:"",
        companyLoyaltyEarnPoint: "",
        companyLoyaltyRedeemPoints: "",
        companyLoyaltyRedeemAmount: "",
        companyLoyaltyPointExpiryDays: "",
        companyEnableMaintenanceMode: "",
        companyEnableMaintenanceModeDescription: "",
        companyAvailability: [],
        action: "add",
      },
      btndisabled: false,
      loading: true,
      tatList: [],
      availabiltyList: [],
      promoList: [],
      formpost: [],
      companyDetail: [],
    };
  }
  componentDidMount() {
    this.loadAvailabilty();
    //this.loadPromotions();

     var params = {
      params:'' ,
      url: `${apiUrl}${module}/getCompanySettings`,
      type: "client",
    };
    this.setState({ pageloading: true });
    this.props.getDetailData(params);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      this.state.formpost !== nextProps.formpost &&
      this.props.formpost != nextProps.formpost
    ) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        this.setState({
          changegeneralInfo: "No",
          changecontactInfo: "No",
          changeavailablity: "No",
          changetax: "No",
          changeInvoice: "No",
          changePromotion: "No",
          changeLoyalty: "No",
          changeSocialMedia: "No",
          changeMailConfig: "No",
          changeMaintenance: "No",
        });
        var errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata) {
      this.setState({ companyDetail: nextProps.detaildata }, function () {
        if (nextProps.detaildata[0].status === "ok") {
          var result = nextProps.detaildata[0].result;

          var companyTaxType =
            result.companyTaxType !== "" &&
            typeof result.companyTaxType !== undefined &&
            typeof result.companyTaxType !== "undefined"
              ? {
                  label: result.companyTaxType,
                  value: result.companyTaxType,
                }
              : "";

          const companyLoyaltyEarnType = result?.companyLoyaltyEarnType ?? '';
          const companyAvailability = result?.companyAvailability ?? '';
          let companyAvailability_Split = [];
          if(companyAvailability!==null && companyAvailability!=="") {
            companyAvailability_Split = companyAvailability.split(',');
          }
          
          var clientupdatedata = {
            companyName: result.companyName,
            companyWebSite: result.companyWebSite,
            companyLogo: result.companyLogo,
            companyPostalCode:
              result.companyPostalCode !== null
                ? result.companyPostalCode
                : "",
                companyUnitNumber:
              result.companyUnitNumber !== null
                ? result.companyUnitNumber
                : "",
                companyFloorNumber:
              result.companyFloorNumber !== null
                ? result.companyFloorNumber
                : "",
                companyAddress:
              result.companyAddress !== null ? result.companyAddress : "",
              companyContactNumber:
              result.companyContactNumber !== null
                ? result.companyContactNumber
                : "",
                companyEmail:
              result.companyEmail !== null
                ? result.companyEmail
                : "",
                companyEnableTax:result?.companyEnableTax ?? false,
                companyTaxType: companyTaxType,
                companyEnableTaxPercentage: result?.companyEnableTaxPercentage || "",
                companyGSTNumber: result?.companyGSTNumber || "",
                companyInvoiceLogo: result?.companyInvoiceLogo || "",
                companyEnableLoyalty: result?.companyEnableLoyalty ?? false,
                companyLoyaltyEarnType: companyLoyaltyEarnType!==""?{label:companyLoyaltyEarnType, value:companyLoyaltyEarnType}:"",
                companyLoyaltyEarnPoint: result?.companyLoyaltyEarnPoint ?? "",
            
                companyLoyaltyRedeemPoints: result?.companyLoyaltyRedeemPoints || "",
                companyLoyaltyRedeemAmount: result?.companyLoyaltyRedeemAmount || "",
                companyLoyaltyPointExpiryDays: result?.companyLoyaltyPointExpiryDays || "",
                companyEnableMaintenanceMode: result?.companyEnableMaintenanceMode ?? false,
            companyEnableMaintenanceModeDescription:
              result?.companyEnableMaintenanceModeDescription || "",
            companyAvailability:companyAvailability_Split,
            action: "edit",
          };
          this.setState({ clientdata: clientupdatedata, pageloading: false });
        } else {
          this.setState({ pageloading: false });
          this.props.history.push(modulePath);
          showAlert("Error", "Invalid Product", "error");
        }
      });
    }
  }

  loadAvailabilty() {
    var urlShringTxt = apiUrl + "availability/companydropDownList";
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      if (res.data.status === "ok") {
        this.setState({ availabiltyList: res.data.result });
      }
    }).catch((e) => {
      console.log(e)
    });
  }
  loadPromotions() {
    var urlShringTxt =
      apiUrl + "clientpanel/promotion/dropdownlist?company_id=" + CompanyID();
    axios.get(urlShringTxt, clientheaderconfig).then((res) => {
      var promoList = [];
      if (res.data.status === "ok") {
        if (res.data.result.length > 0) {
          res.data.result.map((item) => {
            promoList.push({ label: item.label, value: item.label });
          });
        }
      }
      this.setState({ promoList: promoList });
    });
  }

  sateValChange = (field, value) => {
    this.setState({ btndisabled: value });
  };

  /* signin - start*/
  fieldChange = (field, value) => {
    if (
      [
        "companyName",
        "companyWebSite",
        "companyLogo",
      ].indexOf(field) >= 0
    ) {
      this.setState({ changegeneralInfo: "Yes" });
    }
    if (
      [
        "companyPostalCode",
        "companyUnitNumber",
        "companyFloorNumber",
        "companyAddress",
        "companyContactNumber",
        "companyEmail",
      ].indexOf(field) >= 0
    ) {
      this.setState({ changecontactInfo: "Yes" });
    }
    if (["companyAvailability"].indexOf(field) >= 0) {
      this.setState({ changeavailablity: "Yes" });
    }
    if (["companyTaxType", "companyEnableTaxPercentage"].indexOf(field) >= 0) {
      this.setState({ changetax: "Yes" });
    }
    if (["companyGSTNumber", "companyInvoiceLogo"].indexOf(field) >= 0) {
      this.setState({ changeInvoice: "Yes" });
    }
    if (
      [
        "companyLoyaltyEarnPoint",
        "companyLoyaltyRedeemPoints",
        "companyLoyaltyRedeemAmount",
        "companyLoyaltyPointExpiryDays",
      ].indexOf(field) >= 0
    ) {
      this.setState({ changeLoyalty: "Yes" });
    }
    if (
      ["companyEnableMaintenanceMode", "companyEnableMaintenanceModeDescription"].indexOf(
        field
      ) >= 0
    ) {
      this.setState({ changeMaintenance: "Yes" });
    }

    this.setState(
      update(this.state, {
        clientdata: { [field]: { $set: value } },
      })
    );
  };

  handleSubmit = () => {
    showLoader("submit_frm", "class");
    var postData = this.state.clientdata;

    var companyAvailability = [];
    if (postData.companyAvailability.length > 0) {
      postData.companyAvailability.map((item) => {
        companyAvailability.push(item.value);
      });
    }

    var postObject = {
      companyName: postData.companyName,
      companyWebSite: postData.companyWebSite,
      companyLogo: postData.companyLogo,
      companyPostalCode: postData.companyPostalCode,
      companyUnitNumber: postData.companyUnitNumber,
      companyFloorNumber: postData.companyFloorNumber,
      companyAddress: postData.companyAddress,
      companyContactNumber: postData.companyContactNumber,
      companyEmail: postData.companyEmail,
      companyTaxType: postData.companyTaxType?.value ?? '',
      companyEnableTaxPercentage: postData.companyEnableTaxPercentage,
      companyGSTNumber: postData.companyGSTNumber,
      companyInvoiceLogo: postData.companyInvoiceLogo,
      companyLoyaltyEarnType:postData.companyLoyaltyEarnType?.value ?? 'Fixed',
      companyLoyaltyEarnPoint: postData.companyLoyaltyEarnPoint,
      companyLoyaltyRedeemPoints: postData.companyLoyaltyRedeemPoints,
      companyLoyaltyRedeemAmount: postData.companyLoyaltyRedeemAmount,
      companyLoyaltyPointExpiryDays: postData.companyLoyaltyPointExpiryDays,
      
    };
    /* companyAvailability:  companyAvailability, */
    var post_url = `${module}/updateSetting`;
    let method = 'update';
 
    this.props.getFormPost(postObject, post_url, "client", method);
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage="" />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">Settings</h4>
                  </div>
                </div>
                <PostForm
                  {...this.props}
                  fields={this.state.clientdata}
                  btndisabled={this.state.btndisabled}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  sateValChange={this.sateValChange}
                  error_msg={this.state.error_msg}
                  availabiltyList={this.state.availabiltyList}
                  promoList={this.state.promoList}
                  onInvalid={() => {
                    console.log("Form invalid!");
                    setTimeout(function () {
                      if ($("#modulefrm .is-invalid").length > 0) {
                        $("html, body").animate(
                          {
                            scrollTop:
                              $(document)
                                .find("#modulefrm .is-invalid:first")
                                .offset().top - 100,
                          },
                          500
                        );
                      }
                    }, 500);
                  }}
                />
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default connect(mapStateTopProps, mapDispatchToProps)(Form);

const isEmpty = (value) => (value === "" ? "This field is required." : null);
const isNumber = (value) =>
  validator.isNumeric(value) && value === ""
    ? null
    : "This is not a valid number.";
const isValidOption = (taxType, value) => {
  if (Object.keys(taxType).length > 0) {
    return value === "" ? "This field is required." : null;
  }
};
function validationConfig(props) {
  const {
    companyName,
    companyWebSite,
    companyPostalCode,
    companyUnitNumber,
    companyAddress,
    companyEmail,
    companyInvoiceLogo,
    companyTaxType,
    companyEnableTaxPercentage
  } = props.fields;

  return {
    fields: [
      "companyName",
      "companyWebSite",
      "companyPostalCode",
      "companyUnitNumber",
      "companyAddress",
      "companyEmail",
      "companyInvoiceLogo",
      "companyTaxType",
      "companyEnableTaxPercentage",
    ],

    validations: {
      companyName: [[isEmpty, companyName]],
      companyWebSite: [[isEmpty, companyWebSite]],
      companyPostalCode: [
        [isEmpty, companyPostalCode],
        /* [isNumber, companyPostalCode], */
      ],
      companyUnitNumber: [[isEmpty, companyUnitNumber]],
      companyAddress: [[isEmpty, companyAddress]],
      companyEmail: [[isEmpty, companyEmail]],
      companyInvoiceLogo: [[isEmpty, companyInvoiceLogo]],
      companyEnableTaxPercentage: [
        [isValidOption, companyTaxType, companyEnableTaxPercentage],
      ]
    },
  };
}

class PostForm extends Component {
  constructor(props) {
    super(props);
    this.setContent = this.setContent.bind(this);
  }

  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeCheck(name, event) {
    var value = event.target.checked === true ? "Yes" : "No";
    if (name === "companyAvailability") {
      var companyAvailability = this.props.fields.companyAvailability;
      if (
        this.props.fields.companyAvailability.indexOf(event.target.value) >= 0
      ) {
        const index = companyAvailability.indexOf(value);
        companyAvailability.splice(index, 1);
      } else {
        companyAvailability.push(event.target.value);
      }
      value = companyAvailability;
    }

    this.props.onChange(name, value);
  }

  setContent(value) {
    this.props.onChange("companyEnableMaintenanceModeDescription", value);
  }

  async uplaodFiles(imageType) {
    this.props.sateValChange("btndisabled", true);
    showLoader("dz-details", "class");
    showLoader("ImageContainer");
    var imagefile = document.querySelector("#" + imageType);
    const file = imagefile.files[0];
    var fileDetail = await uploadFile(file, "company", "client");
    if (fileDetail.status === "ok") {
      this.props.onChange(imageType, fileDetail.url);
    }
    hideLoader("ImageContainer");
    hideLoader("dz-details", "class");
    $("#" + imageType).val("");
    this.props.sateValChange("btndisabled", false);
  }
  async removeImage(fileNamme, imageType) {
    showLoader("ImageDetails");
    var fileDetail = await removeFile(fileNamme, "client");
    if (fileDetail.status === "ok") {
      hideLoader("ImageDetails");
      this.props.onChange(imageType, "");
    }
  }

 
  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } =
      this.props;
    let errMsgCompanyName,
      errMsgUrl,
      errMsgPostalCode,
      errMsgUnitNo,
      errMsgAddress,
      errMsgEmail,
      errMsgInvoiceLogo,
      errMsgTax = "";
    if ($validation.companyName.error.reason !== undefined) {
      errMsgCompanyName = $validation.companyName.show && (
        <span className="error">{$validation.companyName.error.reason}</span>
      );
    }
    if ($validation.companyWebSite.error.reason !== undefined) {
      errMsgUrl = $validation.companyWebSite.show && (
        <span className="error">
          {$validation.companyWebSite.error.reason}
        </span>
      );
    }
    if ($validation.companyPostalCode.error.reason !== undefined) {
      errMsgPostalCode = $validation.companyPostalCode.show && (
        <span className="error">
          {$validation.companyPostalCode.error.reason}
        </span>
      );
    }
    if ($validation.companyUnitNumber.error.reason !== undefined) {
      errMsgUnitNo = $validation.companyUnitNumber.show && (
        <span className="error">
          {$validation.companyUnitNumber.error.reason}
        </span>
      );
    }

    if ($validation.companyAddress.error.reason !== undefined) {
      errMsgAddress = $validation.companyAddress.show && (
        <span className="error">
          {$validation.companyAddress.error.reason}
        </span>
      );
    }
    if ($validation.companyEmail.error.reason !== undefined) {
      errMsgEmail = $validation.companyEmail.show && (
        <span className="error">{$validation.companyEmail.error.reason}</span>
      );
    }
    if ($validation.companyInvoiceLogo.error.reason !== undefined) {
      errMsgInvoiceLogo = $validation.companyInvoiceLogo.show && (
        <span className="error">
          {$validation.companyInvoiceLogo.error.reason}
        </span>
      );
    }
    if ($validation.companyEnableTaxPercentage.error.reason !== undefined) {
      errMsgTax = $validation.companyEnableTaxPercentage.show && (
        <span className="error">
          {$validation.companyEnableTaxPercentage.error.reason}
        </span>
      );
    }
    return (
      <form className="card fv-plugins-bootstrap5" id="modulefrm">
        <div className="row g-3">
          <div
            className="accordion mt-3 accordion-header-primary"
            id="accordionStyle1"
          >
            <div className="accordion-item active">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionStyle1-3"
                  aria-expanded="true"
                >
                  General Info
                </button>
              </h2>
              <div
                id="accordionStyle1-3"
                className="accordion-collapse collapse show  mt-3"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgCompanyName !== "" &&
                            errMsgCompanyName !== false &&
                            errMsgCompanyName !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="companyName"
                          value={fields.companyName}
                          {...$field("companyName", (e) =>
                            onChange("companyName", e.target.value)
                          )}
                        />
                        <label htmlFor="companyName">
                          Company Name<span className="error">*</span>
                        </label>
                        {errMsgCompanyName}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgUrl !== "" &&
                            errMsgUrl !== false &&
                            errMsgUrl !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="companyWebSite"
                          value={fields.companyWebSite}
                          {...$field("companyWebSite", (e) =>
                            onChange("companyWebSite", e.target.value)
                          )}
                        />
                        <label htmlFor="companyWebSite">
                          Site URL<span className="error">*</span>
                        </label>
                        {errMsgUrl}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3" id="ImageContainer">
                          <label htmlFor="formFile" className="form-label">
                            Company Logo
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            id="companyLogo"
                            onChange={(event) => {
                              this.uplaodFiles("companyLogo", event);
                              return false;
                            }}
                          />
                        </div>
                        {fields.companyLogo !== "" && (
                          <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                            <div className="dz-details" id="ImageDetails">
                              <div className="dz-thumbnail">
                                <img alt="" src={fields.companyLogo} />
                              </div>
                            </div>
                            <a
                              className="dz-remove"
                              href={void 0}
                              onClick={this.removeImage.bind(
                                this,
                                fields.companyLogo,
                                "companyLogo"
                              )}
                            >
                              Remove file
                            </a>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionprice"
                  aria-expanded="false"
                >
                  Contact Info
                </button>
              </h2>

              <div
                id="accordionprice"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgPostalCode !== "" &&
                            errMsgPostalCode !== false &&
                            errMsgPostalCode !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="companyPostalCode"
                          value={fields.companyPostalCode}
                          {...$field("companyPostalCode", (e) =>
                            onChange("companyPostalCode", e.target.value)
                          )}
                        />
                        <label htmlFor="companyPostalCode">
                          Postal Code<span className="error">*</span>
                        </label>
                        {errMsgPostalCode}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgUnitNo !== "" &&
                            errMsgUnitNo !== false &&
                            errMsgUnitNo !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="companyUnitNumber"
                          value={fields.companyUnitNumber}
                          {...$field("companyUnitNumber", (e) =>
                            onChange("companyUnitNumber", e.target.value)
                          )}
                        />
                        <label htmlFor="companyUnitNumber">
                          Unit No.<span className="error">*</span>
                        </label>
                        {errMsgUnitNo}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyFloorNumber"
                          value={fields.companyFloorNumber}
                          {...$field("companyFloorNumber", (e) =>
                            onChange("companyFloorNumber", e.target.value)
                          )}
                        />
                        <label htmlFor="companyFloorNumber">Floor No.</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgAddress !== "" &&
                            errMsgAddress !== false &&
                            errMsgAddress !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="companyAddress"
                          value={fields.companyAddress}
                          {...$field("companyAddress", (e) =>
                            onChange("companyAddress", e.target.value)
                          )}
                        />
                        <label htmlFor="companyAddress">
                          Address<span className="error">*</span>
                        </label>
                        {errMsgAddress}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyContactNumber"
                          value={fields.companyContactNumber}
                          {...$field("companyContactNumber", (e) =>
                            onChange("companyContactNumber", e.target.value)
                          )}
                        />
                        <label htmlFor="companyContactNumber">
                          Contact Number
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgEmail !== "" &&
                            errMsgEmail !== false &&
                            errMsgEmail !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="companyEmail"
                          value={fields.companyEmail}
                          {...$field("companyEmail", (e) =>
                            onChange("companyEmail", e.target.value)
                          )}
                        />
                        <label htmlFor="companyEmail">
                          Email Address<span className="error">*</span>
                        </label>
                        {errMsgEmail}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionstock"
                  aria-expanded="false"
                >
                  Available
                </button>
              </h2>

              <div
                id="accordionstock"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    {this.props.availabiltyList.length > 0 &&
                      this.props.availabiltyList.map((item, index) => {
                        return (
                          <div className="col-md-2" key={index}>
                            <div className="form-check mt-3">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value={item.value}
                                id={"avail_" + index}
                                checked={
                                  fields.companyAvailability.indexOf(
                                    item.value
                                  ) >= 0
                                    ? true
                                    : false
                                }
                                onChange={this.handleChangeCheck.bind(
                                  this,
                                  "companyAvailability"
                                )}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={"avail_" + index}
                              >
                                {item.label}
                              </label>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>

            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionvoucher"
                  aria-expanded="false"
                >
                  Tax Settings
                </button>
              </h2>

              <div
                id="accordionvoucher"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                        <Select
                          value={fields.companyTaxType}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "companyTaxType"
                          )}
                          placeholder="Select Tax Type"
                          options={[
                            { label: "Exclusive", value: "Exclusive" },
                            { label: "Inclusive", value: "Inclusive" },
                          ]}
                        />
                        <label className="select-box-label">Tax Type</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className={
                            errMsgTax !== "" &&
                            errMsgTax !== false &&
                            errMsgTax !== undefined
                              ? "form-control is-invalid"
                              : "form-control"
                          }
                          name="companyEnableTaxPercentage"
                          value={fields.companyEnableTaxPercentage}
                          {...$field("companyEnableTaxPercentage", (e) =>
                            onChange("companyEnableTaxPercentage", e.target.value)
                          )}
                          id="companyEnableTaxPercentage"
                        />
                        <label htmlFor="companyEnableTaxPercentage">
                          Tax Amount Percentage{" "}
                          {fields.companyTaxType !== "" && (
                            <span className="error">*</span>
                          )}
                        </label>
                        {errMsgTax}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item ">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordiongallery"
                  aria-expanded="false"
                >
                  Invoice
                </button>
              </h2>

              <div
                id="accordiongallery"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyGSTNumber"
                          value={fields.companyGSTNumber}
                          {...$field("companyGSTNumber", (e) =>
                            onChange("companyGSTNumber", e.target.value)
                          )}
                        />
                        <label htmlFor="companyGSTNumber">GST Reg. No</label>
                      </div>
                    </div>
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <div className="mb-3">
                          <label htmlFor="formFile" className="form-label">
                            Invoice Logo <span className="error">*</span>
                          </label>
                          <input
                            className={
                              errMsgInvoiceLogo !== "" &&
                              errMsgInvoiceLogo !== false &&
                              errMsgInvoiceLogo !== undefined
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            type="file"
                            id="companyInvoiceLogo"
                            onChange={(event) => {
                              this.uplaodFiles("companyInvoiceLogo", event);
                              return false;
                            }}
                          />

                          {errMsgInvoiceLogo}
                        </div>
                      </div>
                      {fields.companyInvoiceLogo !== "" && (
                        <div className="dz-preview dz-processing dz-image-preview dz-success dz-complete">
                          <div className="dz-details">
                            <div className="dz-thumbnail">
                              <img alt="" src={fields.companyInvoiceLogo} />
                            </div>
                          </div>
                          <a
                            className="dz-remove"
                            href={void 0}
                            onClick={this.removeImage.bind(
                              this,
                              fields.companyInvoiceLogo,
                              "companyInvoiceLogo"
                            )}
                          >
                            Remove file
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordioncombo-1"
                  aria-expanded="false"
                >
                  Loyalty Settings
                </button>
              </h2>

              <div
                id="accordioncombo-1"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                  
                  <div className="col-md-6">
                      <div className="form-floating form-floating-outline custm-select-box mb-4 ">
                        <Select
                          value={fields.companyLoyaltyEarnType}
                          onChange={this.handleSelectChange.bind(
                            this,
                            "companyLoyaltyEarnType"
                          )}
                          placeholder="Select Loyalty Earn Type"
                          options={[
                            { label: "Percentage", value: "Percentage" },
                            { label: "Fixed", value: "Fixed" },
                          ]}
                        />
                        <label className="select-box-label">Loyalty Earn Type</label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyLoyaltyEarnPoint"
                          value={fields.companyLoyaltyEarnPoint}
                          {...$field("companyLoyaltyEarnPoint", (e) =>
                            onChange("companyLoyaltyEarnPoint", e.target.value)
                          )}
                        />
                        <label htmlFor="companyLoyaltyEarnPoint">
                        Loyalty Earn Point
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyLoyaltyRedeemPoints"
                          value={fields.companyLoyaltyRedeemPoints}
                          {...$field("companyLoyaltyRedeemPoints", (e) =>
                            onChange("companyLoyaltyRedeemPoints", e.target.value)
                          )}
                        />
                        <label htmlFor="companyLoyaltyRedeemPoints">
                          Loyalty Redeem Points
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyLoyaltyRedeemAmount"
                          value={fields.companyLoyaltyRedeemAmount}
                          {...$field("companyLoyaltyRedeemAmount", (e) =>
                            onChange("companyLoyaltyRedeemAmount", e.target.value)
                          )}
                        />
                        <label htmlFor="companyLoyaltyRedeemAmount">
                          Loyalty Redeem Amount
                        </label>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-floating form-floating-outline mb-4">
                        <input
                          type="text"
                          className="form-control"
                          name="companyLoyaltyPointExpiryDays"
                          value={fields.companyLoyaltyPointExpiryDays}
                          {...$field("companyLoyaltyPointExpiryDays", (e) =>
                            onChange("companyLoyaltyPointExpiryDays", e.target.value)
                          )}
                        />
                        <label htmlFor="companyLoyaltyPointExpiryDays">
                          Loyalty Expiry Days
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  type="button"
                  className="accordion-button collapsed"
                  data-bs-toggle="collapse"
                  data-bs-target="#accordionmaintenance-1"
                  aria-expanded="false"
                >
                  Maintenance Mode
                </button>
              </h2>

              <div
                id="accordionmaintenance-1"
                className="accordion-collapse collapse"
                data-bs-parent="#accordionStyle1"
              >
                <div className="accordion-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-check mt-3">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value="Yes"
                          id="companyEnableMaintenanceMode"
                          checked={fields.companyEnableMaintenanceMode}
                          onChange={this.handleChangeCheck.bind(
                            this,
                            "companyEnableMaintenanceMode"
                          )}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="companyEnableMaintenanceMode"
                        >
                          Maintenance Mode
                        </label>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <label>Maintenance Mode Description</label>
                      <Editor
                        setContent={this.setContent}
                        data={fields.companyEnableMaintenanceModeDescription}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="pt-1 pb-4 pr-2 text-end"
            style={{ paddingRight: "20px" }}
          >
            <button
              type="button"
              disabled={this.props.btndisabled}
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                if (!this.props.btndisabled) {
                  this.props.$submit(onValid, onInvalid);
                }
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
